import { Modal } from "antd";
import React from "react";
import { svg } from "../../../../../Assets/svg";
import { RootState, useAppSelector } from "../../../../../store";
import { BtnLoader } from "../../../../../Components/Components";

const MarkAsDoneDispatchModal = ({
  visible,
  setIsModalVisible,
  selectedLoad,
  onSucess,
  title = "",
  description = "",
}: any) => {
  const { updateDispatchStatusLoading } = useAppSelector(
    (state: RootState) => state.loading,
  );

  const onClose = () => {
    setIsModalVisible(false);
  };
  return (
    <Modal
      title={<div className="text-center fs-4 fw-bolder lh-m">{title}</div>}
      visible={visible}
      onCancel={onClose}
      width={"33.75rem"}
      closeIcon={svg.closeIcon}
      centered
      footer={
        <div className="d-flex justify-content-center gap-4">
          <button
            type="button"
            className="btn btn-lg btn-outline-secondary min-w-130"
            onClick={onClose}
            disabled={updateDispatchStatusLoading}
          >
            CLOSE
          </button>
          <button
            type="button"
            className="btn btn-lg btn-primary min-w-130"
            onClick={onSucess}
            disabled={updateDispatchStatusLoading}
          >
            {updateDispatchStatusLoading ? <BtnLoader /> : "YES, CONFIRM"}
          </button>
        </div>
      }
      className="commonModalClass"
    >
      <div className="modal-body page-form">
        <p className="text-center">{description}</p>
      </div>
    </Modal>
  );
};

export default MarkAsDoneDispatchModal;
